import { AppFunctionComponent } from "../../../types"
import React, { ReactNode } from "react"
import styled from "styled-components"
import Section from "../../../components/common/sections/section.component"
import { css } from "styled-components"
import { useLocation } from "@reach/router"
import {
  checkIfIsMainPage,
  checkIfIsOnlyMainPage,
} from "../../../helpers/location"

const Wrapper = styled.div<{ isMainPage?: boolean }>`
  & + * {
    ${({ isMainPage }) =>
      isMainPage
        ? css`
            margin-top: calc(var(--grid-spacing) * -1 + -15px);
          `
        : css`
            margin-top: calc(var(--grid-spacing) * -1 + 10px);
          `}
  }
`

interface Props {
  breadcrumbsMenu: ReactNode
  landing?: boolean
}

const TopNavigationWrapper: AppFunctionComponent<Props> = ({
  landing,
  breadcrumbsMenu,
}) => {
  const location = useLocation()
  return !landing ? (
    <Wrapper isMainPage={checkIfIsOnlyMainPage(location.pathname)}>
      {" "}
      <Section isFullWidth={checkIfIsMainPage(location.pathname)}>
        {breadcrumbsMenu}
      </Section>
    </Wrapper>
  ) : (
    <></>
  )
}

export default TopNavigationWrapper
